import car from "../assets/car.png";

function Hero() {

  return (

    <section className="hero">

      <div className="hero-left">

        <h1>

          Car Dealing Experience <br/>

          <span>Redefined!</span>

        </h1>

        <p>

          Discover luxury performance vehicles
          with modern engineering and style.

        </p>

        <button className="btn">

          Explore Cars

        </button>

      </div>

      <div className="hero-right">

        <img
          src={car}
          alt="car"
        />

      </div>

    </section>

  );
}

export default Hero;